import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyB5m6CoQcmBv5L5OKAbv_fj0Y-0qwuEl4Q",
  authDomain: "stimu-22530.firebaseapp.com",
  projectId: "stimu-22530",
  storageBucket: "stimu-22530.firebasestorage.app",
  messagingSenderId: "1050547320680",
  appId: "1:1050547320680:web:7ef41aaf1cce2f07e748dd",
  measurementId: "G-J877F26L4H"
};

const app = initializeApp(firebaseConfig);

export default app;